import { callApi } from "./api.service";

export const ToggleNotification = async (
  Data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/user/toggle-notification`;
  return await callApi(endpoint, "POST", true, getToken, Data);
};

export const GetNotifications = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/user/get-notification-status`;
  return await callApi(endpoint, "GET", true, getToken);
};

export const UpdateNotifications = async (
  Data:any,
  getToken: ()=> Promise<string|null>
) =>{
  const endpoint = `/api/notification/update-notifications`;
  return await callApi(endpoint, "POST", true, getToken, Data)
}